var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-dialog",
    {
      attrs: { value: _vm.value },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event)
        },
      },
    },
    [
      _c(
        "q-card",
        { staticStyle: { "min-width": "900px", "max-width": "1200px" } },
        [
          _c(
            "q-card-section",
            { staticClass: "row items-center q-pb-none bg-red text-white" },
            [
              _c("div", { staticClass: "text-h6" }, [
                _vm._v("규제별 정량값 판단 기준 매뉴얼"),
              ]),
              _c("q-space"),
              _c("q-btn", {
                directives: [{ name: "close-popup", rawName: "v-close-popup" }],
                staticClass: "text-white",
                attrs: { icon: "close", flat: "", round: "", dense: "" },
              }),
            ],
            1
          ),
          _c(
            "q-card-section",
            {
              staticClass: "q-pa-md",
              staticStyle: { "max-height": "80vh", "overflow-y": "auto" },
            },
            [
              _c("div", { staticClass: "q-mb-sm text-caption text-grey-8" }, [
                _vm._v(" ※ "),
                _c("b", [_vm._v("규제 판단 기준")]),
                _vm._v(" 컬럼을 기준으로 입력해야 할 항목이 결정됩니다. "),
              ]),
              _c(
                "q-markup-table",
                {
                  staticClass: "text-caption",
                  attrs: {
                    flat: "",
                    bordered: "",
                    separator: "cell",
                    dense: "",
                  },
                },
                [
                  _c("thead", { staticClass: "bg-grey-3 text-weight-bold" }, [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "15%" },
                        },
                        [_vm._v("법령")]
                      ),
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "35%" },
                        },
                        [_vm._v("규제 항목")]
                      ),
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "15%" },
                        },
                        [_vm._v("규제 판단 기준")]
                      ),
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "35%" },
                        },
                        [_vm._v("입력 항목")]
                      ),
                    ]),
                  ]),
                  _c(
                    "tbody",
                    [
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass:
                              "text-center text-weight-bold bg-blue-1",
                            attrs: { rowspan: "3" },
                          },
                          [_vm._v(" 산업안전보건법 ")]
                        ),
                        _c("td", [
                          _vm._v(" 제조금지물질 / 허가대상유해물질"),
                          _c("br"),
                          _vm._v(" 관리대상유해물질 / 작업환경측정대상"),
                          _c("br"),
                          _vm._v(" 특수건강진단대상 / 특별관리물질 "),
                        ]),
                        _c(
                          "td",
                          {
                            staticClass:
                              "text-center text-primary text-weight-bold",
                          },
                          [_vm._v("정량값")]
                        ),
                        _c("td", [
                          _c("div", [_vm._v("부등호")]),
                          _c("div", [_vm._v("정량값 (함유량)")]),
                          _c("div", [_vm._v("단위")]),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [
                          _vm._v("노출기준설정물질 / 허용기준설정물질"),
                        ]),
                        _c(
                          "td",
                          {
                            staticClass:
                              "text-center text-primary text-weight-bold",
                          },
                          [_vm._v(" STEL, TWA ")]
                        ),
                        _c("td", [
                          _c("div", [_vm._v("TWA (ppm, mg/㎥)")]),
                          _c("div", [_vm._v("STEL (ppm, mg/㎥)")]),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [_vm._v("PSM제출대상물질")]),
                        _c(
                          "td",
                          {
                            staticClass:
                              "text-center text-primary text-weight-bold",
                          },
                          [_vm._v(" 규정수량 ")]
                        ),
                        _c("td", [
                          _c("div", [_vm._v("규정수량")]),
                          _c("div", [_vm._v("단위")]),
                        ]),
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass:
                              "text-center text-weight-bold bg-orange-1",
                            attrs: { rowspan: "4" },
                          },
                          [_vm._v(" 화학물질관리법 ")]
                        ),
                        _c("td", [_vm._v("기존화학물질 / 중점관리물질")]),
                        _c("td", { staticClass: "text-center text-grey-6" }, [
                          _vm._v("단순 지정"),
                        ]),
                        _c("td", { staticClass: "text-grey-6" }, [
                          _vm._v("입력 항목 없음"),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [_vm._v("제한물질 / 금지물질")]),
                        _c(
                          "td",
                          {
                            staticClass:
                              "text-center text-primary text-weight-bold",
                          },
                          [_vm._v("정량값")]
                        ),
                        _c("td", [
                          _c("div", [_vm._v("부등호")]),
                          _c("div", [_vm._v("정량값")]),
                          _c("div", [_vm._v("단위")]),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [
                          _vm._v("사고대비물질 / 인체급성·만성·생태유해성물질"),
                        ]),
                        _c(
                          "td",
                          {
                            staticClass:
                              "text-center text-primary text-weight-bold",
                          },
                          [_vm._v(" 규정수량, 함유량 ")]
                        ),
                        _c("td", [
                          _c("div", [_vm._v("함유량 (%)")]),
                          _c("div", [_vm._v("규정수량")]),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [_vm._v("배출량조사대상 (PRTR 1, 2그룹)")]),
                        _c(
                          "td",
                          {
                            staticClass:
                              "text-center text-primary text-weight-bold",
                          },
                          [_vm._v(" 취급량, 함유량 ")]
                        ),
                        _c("td", [
                          _c("div", [_vm._v("함유량 (%)")]),
                          _c("div", [_vm._v("취급량 (톤/년)")]),
                        ]),
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass:
                              "text-center text-weight-bold bg-red-1",
                          },
                          [_vm._v(" 위험물안전관리법 ")]
                        ),
                        _c("td", [_vm._v("제1류 ~ 제6류 위험물")]),
                        _c(
                          "td",
                          {
                            staticClass:
                              "text-center text-primary text-weight-bold",
                          },
                          [_vm._v(" 사업장 총 허가배수 ")]
                        ),
                        _c("td", [
                          _c("div", [_vm._v("지정수량")]),
                          _c(
                            "div",
                            { staticClass: "text-weight-bold text-red" },
                            [_vm._v(" 사업장 총 허가배수는 직접 확인 필요 ")]
                          ),
                        ]),
                      ]),
                      _vm._l(_vm.simpleLaws, function (law) {
                        return _c("tr", { key: law.name }, [
                          _c(
                            "td",
                            {
                              staticClass: "text-center text-weight-bold",
                              class: law.bgColor,
                            },
                            [_vm._v(" " + _vm._s(law.name) + " ")]
                          ),
                          _c("td", {
                            domProps: { innerHTML: _vm._s(law.items) },
                          }),
                          _c("td", { staticClass: "text-center text-grey-6" }, [
                            _vm._v("단순 지정"),
                          ]),
                          _c("td", { staticClass: "text-grey-6" }, [
                            _vm._v("입력 항목 없음"),
                          ]),
                        ])
                      }),
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass:
                              "text-center text-weight-bold bg-green-1",
                          },
                          [_vm._v(" 폐기물관리법 ")]
                        ),
                        _c("td", [_vm._v("폐유기용제 / 지정폐기물")]),
                        _c(
                          "td",
                          {
                            staticClass:
                              "text-center text-primary text-weight-bold",
                          },
                          [_vm._v("정량값")]
                        ),
                        _c("td", [
                          _c("div", [_vm._v("부등호")]),
                          _c("div", [_vm._v("정량값")]),
                          _c("div", [_vm._v("단위")]),
                        ]),
                      ]),
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "q-card-actions",
            { staticClass: "bg-grey-1", attrs: { align: "right" } },
            [
              _c("q-btn", {
                directives: [{ name: "close-popup", rawName: "v-close-popup" }],
                attrs: { flat: "", label: "닫기", color: "primary" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }